/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:e3012970-dfb7-4a99-90dc-406b477c6a66",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_eRMXDjL0n",
    "aws_user_pools_web_client_id": "59kr01lgq106i3hg69t3e15jee",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://bp6in5z4ibferl2bkfyxydfg2a.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "5ginternational63471a9cb1b54b1caab0d956dc7fcae7172859-master",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
